import SellerReviewsStarRating from "@components/Seller/SellerReviews/SellerReviewsStarRating";
import Pagination from "@components/Pagination";

const dateOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

const SellerReviewList = ({ reviews, setPage }) => {
  const goToPage = (page) => {
    setPage(page - 1);
    window.scrollTo({ top: 400, left: 0, behavior: "smooth" });
  };
  return (
    <div>
      <ul>
        {!!reviews &&
          reviews.items &&
          reviews.items.length > 0 &&
          reviews.items.map((review, index) => {
            const reviewDate = new Date(
              review.updatedAt ? review.updatedAt : review.createdAt
            ).toLocaleDateString("ro-RO", dateOptions);
            return (
              <li className="md:flex mt-6" key={review._id}>
                <p className="py-2 md:py-0 md:flex flex-col md:min-w-[20%] leading-22 -tracking-0.16">
                  <span className="text-base font-semibold">
                    {review.customer.alias || review.customer.name}
                  </span>
                  <span className="mx-2 text-gray-1200 md:hidden">&#8226;</span>
                  <span className="text-gray-1200">{reviewDate}</span>
                </p>
                <div
                  className={`w-full pb-6 border-b border-gray-1100 ${
                    reviews.meta.total_pages === 1 &&
                    reviews.meta.size - 1 === index
                      ? "border-none"
                      : ""
                  }`}
                >
                  <SellerReviewsStarRating reviewsRating={review.rating} />
                  <p className="break-all text-sm leading-22 ">{review.body}</p>
                </div>
              </li>
            );
          })}
      </ul>

      {!!reviews && reviews.meta && reviews.meta.size > reviews.meta.limit && (
        <div className="md:flex justify-end my-8">
          <div className="w-full md:w-5/6 pl-0 md:pl-8 mt-10px mb-12 md:mb-0 md:mt-0">
            <Pagination
              pages={reviews.meta.total_pages}
              goTo={(pg) => goToPage(pg)}
              activePage={reviews.meta.page + 1}
              meta={reviews.meta}
              showMeta={true}
              alignment="justify-center"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerReviewList;
